<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="6">
                <restaurantorder-edit-form
                    title="Create new partner order"
                    v-bind:order="order"
                    v-on:submit="submit"
                    v-on:cancel="$router.go(-1)"
                    v-on:servicecharge-retrieved="onServicechargeRetrieved"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import restaurantApi from '@/api/restaurantApi';
import snackbar from '@/utils/snackbar';

export default {
    components: {
        'restaurantorder-edit-form': () =>
            import('@/views/op/RestaurantOrderEditForm.vue')
    },
    data() {
        return {
            order: {
                customer_name: null,
                customer_phone: null,
                payment_type: null,
                service_charge: null,
                operator_notes: null,
                restaurantorder_new_photo: null,
                orderable: {
                    restaurant_id: null,
                    destination_id: null,
                    amount: null,
                    customer_notes: null,
                    prep_minutes: null
                }
            }
        };
    },
    methods: {
        async submit() {
            const restaurantId = this.order.orderable.restaurant_id;
            const response = await restaurantApi.createRestaurantOrder(
                restaurantId,
                this.order
            );
            this.$router.push({
                name: 'op-restaurantorder-show',
                params: { order_id: response.data.order.id }
            });
            snackbar.show('Order created', 'success');
        },
        onServicechargeRetrieved(servicecharge) {
            this.order.service_charge =
                null != servicecharge ? servicecharge.service_charge : null;
        }
    }
};
</script>
